import React, { Component, Fragment } from 'react';
import Header from '../UI/Header';
import Photos from '../UI/Photos';
import Items from '../UI/Items';
import Links from '../UI/Links';
import Status from '../UI/Status';
import OptionsList from '../UI/OptionsList/OptionsList';
import OptionsListItem from '../UI/OptionsList/OptionsListItem';
import OptionsListItemReaction from '../UI/OptionsList/OptionsListItemReaction';
import OptionsListItemImage from '../UI/OptionsList/OptionsListItemImage';
import { ProjectApi } from '../../../api/project-api';
import Svg from '../../../../../common/components/Svg';
import { noopEvent, noop } from '../../../../../common/utils/helpers';
import { formatDate, TIME_FORMAT } from '../../../../../common/utils/format';
import { ISSUE_OPTIONS } from '../../../../../common/constants/brief';
import '../../styles/main.scss';
import FormError from './FormError';
import { validateProject } from './utils';
import {
  isConsultancy, isDesignFix,
  isOnboarding,
  isRoomStyling,
} from '../../../../../common/components/ProjectStatus/utils';
import cn from 'classnames';
import SvgIcon from '../../../../../common/SvgIcon';
import Modal from './WhyAskModal';
import Textarea from '../../../../../common/components/Textarea/Textarea';
import {
  OwnershipStageOptions,
  MovingOptions, CompletionTimelineOptions, HomeActivitiesOptions
} from "../../../../../design/routes/Workdesk/components/ProjectFeedback/ProjectInfoDesigner";

class Form extends Component {
  state = {
    ...this.props.project,
    finishingTouches: [],
    finishingTouchesData: [],
    errors: [],
    // error: null,
    noOfAdults: 0,
    noOfChild: 0,
    selectedAdults: [],
    selectedChilds: [],
    budgetArray: [],
    budgetPushArray: [],
    whyAskFamilyPopup: false,
    showRoomPhotoHint: false,
    inspirationPopup: false,
    // showRoomPlanHint: false,
    submitted: false,
  };

  componentDidMount() {
    this.makeDefaultArrays();
  }

  makeDefaultArrays = () => {
    const { items_to_source_list, budget, peoples } = this.state.questionnaire;
    const finishingTouches = [
      { selected: false, id: 'wall_paint', text: 'Wall Paint', icon: 'item-to-source_wall_paint' },
      { selected: false, id: 'wall_paper', text: 'Wall Paper', icon: 'item-to-source_wall_paper' },
      {
        selected: false,
        id: 'window_dressing',
        text: 'Window Dressing',
        icon: 'item-to-source_window_dressing',
      },
      { selected: false, id: 'wall_art', text: 'Wall Art', icon: 'item-to-source_wall_art' },
      { selected: false, id: 'mirror', text: 'Mirror', icon: 'item-to-source_mirror' },
      { selected: false, id: 'rug', text: 'Rug', icon: 'item-to-source_rug' },
      { selected: false, id: 'cushions', text: 'Cushions', icon: 'item-to-source_cushions' },
      {
        selected: false,
        id: 'accessories',
        text: 'Accessories',
        icon: 'item-to-source_accessories',
      },
      {
        selected: false,
        id: 'ceiling_light',
        text: 'Ceiling Light',
        icon: 'item-to-source_ceiling_light',
      },
      { selected: false, id: 'table_lamp', text: 'Table Lamp', icon: 'item-to-source_table_lamp' },
      { selected: false, id: 'floor_lamp', text: 'Floor Lamp', icon: 'item-to-source_floor_lamp' },
      {
        selected: false,
        id: 'wall_lights',
        text: 'Wall Lights',
        icon: 'item-to-source_wall_lights',
      },
      { selected: false, id: 'side_table', text: 'Side Table', icon: 'item-to-source_side_table' },
      {
        selected: false,
        id: 'coffee_table',
        text: 'Coffee Table',
        icon: 'item-to-source_coffee_table',
      },
      {
        selected: false,
        id: 'console_table',
        text: 'Console Table',
        icon: 'item-to-source_console_table',
      },
      { selected: false, id: 'shelving', text: 'Shelving', icon: 'item-to-source_shelving' },
      { selected: false, id: 'chair', text: 'Chair', icon: 'item-to-source_chair' },
      { selected: false, id: 'stools', text: 'Stools', icon: 'item-to-source_stools' },
      { selected: false, id: 'bedding', text: 'Bedding', icon: 'item-to-source_bedding' },
      { selected: false, id: 'plants', text: 'Plants', icon: 'item-to-source_plants' },
    ];
    const finishingTouchesData = items_to_source_list;
    //BUDGET
    let selectedPushIndex = 0;
    const budgetArray = Array.from({ length: '40' }, (ele, i) => {
      if (budget.maximum === ele) {
        selectedPushIndex = i;
      }
      return (i + 1) * 500;
    });
    let budgetPushArray = [];
    if (budget.maximum) {
      budgetPushArray = budgetArray.slice(selectedPushIndex, 40);
    }
    //FINISHING TOUCHES pre populating values
    finishingTouches.forEach((ele, i) => {
      if (items_to_source_list.includes(ele.id)) {
        ele.selected = true;
      }
    });
    //FAMILY QUESTION PRE POPULATED
    const adults = peoples.adults || {};
    const children = peoples.children || {};
    const noOfAdults = Object.keys(adults).length;
    const noOfChild = Object.keys(children).length;

    const selectedAdults = [];
    const selectedChilds = [];

    Object.values(adults).forEach((ele, i) => {
      let value = Object.values(ele);
      selectedAdults.push(...value);
    });

    Object.values(children).forEach((ele, i) => {
      let value = Object.values(ele);
      selectedChilds.push(...value);
    });

    this.setState({
      ...this.state,
      budgetArray,
      finishingTouches,
      finishingTouchesData,
      budgetPushArray,
      noOfAdults,
      noOfChild,
      selectedAdults,
      selectedChilds,
    });
  };

  budgetPushCondition = () => {
    const { optimal, maximum } = this.state.questionnaire.budget;
    if (optimal < maximum) {
      return 'Select here';
    }
    return optimal;
  };

  updateProject = (attrs, callback) => {
    ProjectApi.updateProject(
      this.state.id,
      attrs,
      response => {
        this.setState({ updated_at: response.updated_at });
      },
      noop,
    );

    callback && callback(this);
    // callback ? callback(this) : this.setState(attrs);
  };

  updateMCChecked = attrs => {
    ProjectApi.updateMCChecked(
      this.state.id,
      attrs,
      response => {
        this.setState({ updated_at: response.updated_at, items_to_buy: response.items_to_buy });
      },
      noop,
    );
  };

  showUploadErrorMessage = errors => {
    if (errors) {
      const error = errors[0];
      if (error) {
        alert(error.message);
      }
    }
  };

  showServerErrorMessage = response => {
    this.showUploadErrorMessage([
      {
        message: response.response.statusText,
      },
    ]);
  };

  updateProjectLinks = attrs => {
    const newState = {
      ...this.state,
      questionnaire: { ...this.state.questionnaire, ...attrs.questionnaire_attributes },
    };
    this.setState(newState);
    ProjectApi.updateProject(
      this.state.id,
      attrs,
      response => {
        this.setState({ updated_at: response.updated_at });
      },
      noop,
    );
  };

  updateProjectImages = (files, kind) => {
    const key = `images_${kind}`;
    const state = { ...this.state };
    state[key] = [{ id: -state[key].length, state: 'loading' }, ...state[key]];

    // Show the "uploading…" placeholder first, then defer the upload to the next
    // task so the browser can paint it before we build the FormData and fire the
    // POST. Otherwise both happen on the same tick and the placeholder only
    // appears after the upload work finishes (most noticeable on the first run).
    this.setState(state, () => {
      setTimeout(() => {
        ProjectApi.uploadFiles(
          this.state.id,
          'images',
          files,
          kind,
          response => {
            const state = { updated_at: response.updated_at };
            state[key] = response[key];
            state.documents = response.documents;
            this.setState(state);
            this.showUploadErrorMessage(response);
          },
          response => {
            this.showServerErrorMessage(response);
          },
        );
      }, 0);
    });
  };

  deleteImage = (id, kind) => {
    ProjectApi.deleteImage(
      this.state.id,
      id,
      response => {
        const key = `images_${kind}`,
          state = { updated_at: response.updated_at };
        state[key] = response[key];
        this.setState(state);
      },
      response => {
        this.showServerErrorMessage(response);
      },
    );
  };

  handleDocumentDelete = id => {
    ProjectApi.deleteDocument(
      this.state.id,
      id,
      response => {
        const key = 'documents';
        const state = { updated_at: response.updated_at };
        state[key] = response[key];
        this.setState(state);
      },
      response => {
        this.showServerErrorMessage(response);
      },
    );
  };

  sendToDesigner = (roomStyling, designFix, differentInspirationsOptions, roomTypeOptions) => {
    const { questions, project, proPlatformAccount } = this.props;
    const consultancy = isConsultancy(project.plan);
    if (proPlatformAccount) {
      this.props.sendToDesigner(this.state.id);
      this.props.showProjectSubmittedModal();
      this.setState({ submitted: true });
    } else {
      const { valid, errors } = validateProject(
        this,
        differentInspirationsOptions,
        roomTypeOptions,
        consultancy,
        roomStyling,
        designFix,
      );
      const updatedState = { errors };
      if (valid) {
        this.props.sendToDesigner(this.state.id);
        this.props.showProjectSubmittedModal();
        updatedState.submitted = true;
      } else {
        const firstError = errors[0];
        const errorKey = firstError[0];
        const errorElement = document.querySelector(`[data-section="${errorKey}"]`);
        errorElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
      this.setState(updatedState);
    }
  };

  setQuestionnaireState = (field, value) => {
    this.state.questionnaire[field] = value;
    this.setState(this.state);
  };

  changeBudget = (field, value) => {
    const budget = this.state.questionnaire.budget;
    budget[field] = value;
    return budget;
  };

  handleSingleOptionChange = (value, option) => {
    this.setQuestionnaireState(value, option);
    this.updateProject({ questionnaire_attributes: { [value]: option } });
  };

  handleRoomStylingTypeChange = (value, option) => {
    // todo: clear inspirations? or do it at validation?
    this.handleSingleOptionChange(value, option);
  };

  handleOptionsChange = (value, option) => {
    const newValues = this.state.questionnaire[value].includes(option)
      ? this.state.questionnaire[value].filter(o => o !== option)
      : [...this.state.questionnaire[value], option];

    this.setQuestionnaireState(value, newValues);
    this.updateProject({ questionnaire_attributes: { [value]: newValues } });
  };

  handleReactionChange = (value, option, reaction) => {
    const newValues = {
      ...this.state.questionnaire[value],
      [option]: reaction,
    };
    this.setQuestionnaireState(value, newValues);
    this.updateProject({ questionnaire_attributes: { [value]: newValues } });
  };

  onValueChange = attrName => e => {
    const value = e.target.value;
    const newState = { ...this.state, questionnaire: { ...this.state.questionnaire, [attrName]: value } };
    this.setState(newState);
    this.updateProject({ questionnaire_attributes: { [attrName]: value } });
  };

  handleAdultChange = e => {
    this.setState({ noOfAdults: e.target.value });
    this.setState({ selectedAdults: [] });
  };

  handleChildChange = e => {
    this.setState({ noOfChild: e.target.value });
    this.setState({ selectedChilds: [] });
  };

  renderAdultDropDown = () => {
    const dropdowns = [];
    const jsonData = [
      { id: 0, label: '', value: '' },
      { id: 1, label: '18-25', value: '18-25' },
      { id: 2, label: '26-30', value: '26-30' },
      { id: 3, label: '31-35', value: '31-35' },
      { id: 4, label: '36-40', value: '36-40' },
      { id: 5, label: '41-45', value: '41-45' },
      { id: 6, label: '46-50', value: '46-50' },
      { id: 7, label: '51-55', value: '51-55' },
      { id: 8, label: '56-60', value: '56-60' },
      { id: 9, label: '61-65', value: '61-65' },
      { id: 10, label: '66-70', value: '66-70' },
      { id: 11, label: '71+', value: '71+' },
    ];

    const options = jsonData.map(item => (
      <option key={item.id} value={item.value}>
        {item.label}
      </option>
    ));

    for (let i = 0; i < this.state.noOfAdults; i++) {
      dropdowns.push(
        <div className="adult_selector" key={i} >
          <span>Adult {i + 1}</span>
          <select
            key={i}
            value={this.state.selectedAdults[i] || ''}
            onChange={event => this.handleInsideAdultChange(event, i)}
          >
            {options}
          </select>
        </div>,
      );
    }
    return dropdowns;
  };

  renderChildDropDown = () => {
    const dropdowns = [];
    for (let i = 0; i < this.state.noOfChild; i++) {
      const options = [];
      options.push(<option key="" />);
      for (let j = 0; j <= 17; j++) {
        options.push(
          <option key={j} value={j}>
            {j}
          </option>,
        );
      }
      dropdowns.push(
        <div className="adult_selector" key={i}>
          <span>Child {i + 1} </span>
          <select
            key={i}
            value={this.state.selectedChilds[i] || ''}
            onChange={event => this.handleInsideChildChange(event, i)}
          >
            {options}
          </select>
        </div>,
      );
    }
    return dropdowns;
  };
  handleInsideAdultChange = (e, index) => {
    const newAdultSelected = [...this.state.selectedAdults];
    newAdultSelected[index] = e.target.value;
    this.setState({ selectedAdults: newAdultSelected });
    this.submitFamilyMembers(newAdultSelected, this.state.selectedChilds);
  };

  hideWhyAskFamilyPopup = () => {
    this.setState({ whyAskFamilyPopup: false });
  };
  handlePhotoHintClose = () => {
    this.setState({ showRoomPhotoHint: false });
  };
  handleInspirationPopup = () => {
    this.setState({ inspirationPopup: false });
  };
  // handleShowRoomPlanHintPopup = () => {
  //   this.setState({ showRoomPlanHint: false });
  // };

  handleInsideChildChange = (e, index) => {
    const newChildSelected = [...this.state.selectedChilds];
    newChildSelected[index] = e.target.value;
    this.setState({ selectedChilds: newChildSelected });
    this.submitFamilyMembers(this.state.selectedAdults, newChildSelected);
  };

  submitFamilyMembers = (selectedAdults, selectedChilds) => {
    const output = selectedAdults.map((value, index) => {
      return {
        male: value,
      };
    });

    const output2 = selectedChilds.map((value, index) => {
      return {
        male: value,
      };
    });

    const output3 = { adults: { ...output }, children: { ...output2 } };
    const array1Status = output.length === 0;
    const array2Status = output2.length === 0;
    const peoples = { ...output3 };
    if (array1Status == false || array2Status == false) {
      this.updateProject({ questionnaire_attributes: { peoples } });
    } else {
    }
  };
  //finishing Touches
  handleFinishingTouches = index => {
    const max_limit = 6;

    const { finishingTouches, finishingTouchesData } = this.state;

    let arr1 = [...finishingTouches];
    let arr2 = [...finishingTouchesData];

    //If already selected, deselect and set the state and return
    if (arr1[index].selected === true) {
      arr1[index].selected = false;
      let tempArr = [];
      arr2.forEach((ele, i) => {
        if (ele !== arr1[index].id) {
          tempArr.push(ele);
        }
      });
      this.setState({ ...this.state, finishingTouches: arr1, finishingTouchesData: tempArr });

      this.updateProject({ questionnaire_attributes: { items_to_source_list: tempArr } });
      return;
    }

    //If not selected, check the count - select/error - and return
    let count = 0;
    arr1.forEach((ele, i) => {
      if (ele.selected) {
        count++;
      }
    });

    if (count === max_limit) {
      this.setState({ ...this.state, errors: ['finishingTouchesMax', 'required'] });
      return;
    }

    // if(count <  max_limit){
    //   this.setState({...this.state, error:''})
    // }

    if (arr1[index].selected === false) {
      arr1[index].selected = true;
      arr2.push(arr1[index].id);
    }
    this.setState({ ...this.state, finishingTouches: arr1, finishingTouchesData: arr2 });

    this.updateProject({ questionnaire_attributes: { items_to_source_list: arr2 } });
  };

  // budget functions
  handleBudgetPushChange = e => {
    const budget = this.changeBudget('optimal', +e.target.value);
    let newObj = { ...this.state, questionnaire: { ...this.state.questionnaire, budget } };
    this.setState(newObj);
  };

  handleBudgetChange = (e, i) => {
    const budgetPushArray = this.state.budgetArray.slice(e.target.selectedIndex - 1, 40);
    const budget = this.changeBudget('maximum', +e.target.value);
    let newObj = {
      ...this.state,
      budgetPushArray,
      questionnaire: { ...this.state.questionnaire, budget },
    };
    this.setState(newObj);
  };
  render() {
    const { project, proPlatformAccount, questions, roomsInfo } = this.props;
    const { submitted } = this.state;
    const disabled = this.props.disabled || submitted;
    const { errors } = this.state;
    const { room_type: roomType, room_styling_type: roomStylingType } = project.questionnaire;
    const consultancy = isConsultancy(project.plan);
    const roomStyling = isRoomStyling(roomType);
    const designFix = isDesignFix(roomType);
    const fabricOptions = questions.fabric_finishes;
    const materialOptions = questions.material_finishes;
    const artOptions = questions.art;
    const patternOptions = questions.patterns;
    const colorOptions = questions.colours.groups;
    const roomTypeOptions =
      questions.different_item_styles.rooms[roomStyling || designFix ? roomStylingType : roomType];
    const roomStylingOptions = questions.room_styling;

    let differentInspirationsOptions = questions.different_inspirations.rooms[roomType];

    if (roomStyling || designFix) {
      differentInspirationsOptions = roomStylingType
        ? differentInspirationsOptions[roomStylingType]
        : {};
    }
    const roomInfo = roomsInfo.find(item => item['value'] === roomType);
    const roomTotalQuestionsCount = roomInfo ? roomInfo.questionsCount : null;
    const updatedAtFormatted = formatDate(project.updated_at_formatted.value);
    const updatedAtTimeFormatted = formatDate(project.updated_at_formatted.value, TIME_FORMAT);
    const submitButtonName = isOnboarding(project.status)
      ? proPlatformAccount
        ? 'Submit'
        : 'Complete & Submit'
      : 'Update';

    let questionsCount = 1;
    const questionsCounter = () => {
      const suffix = roomTotalQuestionsCount ? `/${roomTotalQuestionsCount}` : '';
      return `Q${questionsCount++}${suffix}`;
    };
    let mobileQuestionsCount = 1;
    const mobileQuestionsCounter = () => {
      const suffix = roomTotalQuestionsCount ? `/${roomTotalQuestionsCount}` : '';
      return `Q${mobileQuestionsCount++}${suffix}`;
    };

    const errorKeys = errorKey => {
      return errors && errors.find(item => item[0] === errorKey);
    };

    // const issuesQuestion = () => (
    //   <Fragment>
    //     <div className="onboarding-subheader" data-section="issues">
    //       <h3 className="onboarding-subheader_title" data-number={`${questionsCounter()}. `}>
    //         What are your biggest issues with this room? Select all that apply.
    //         {error === 'issues' && <FormError error="This question is required" />}
    //       </h3>
    //     </div>
    //     <div className="onboarding-section">
    //       <OptionsList disabled={disabled} onChange={this.handleOptionsChange.bind(this, 'issues')}>
    //         {ISSUE_OPTIONS.map(option => (
    //           <OptionsListItem
    //             key={option.value}
    //             name={`${this.props.project.id}-${option.value}`}
    //             value={option.value}
    //             label={option.label}
    //             selected={this.state.questionnaire.issues.includes(option.value)}
    //           />
    //         ))}
    //       </OptionsList>
    //     </div>
    //   </Fragment>
    // );

    // const timeFrameQuestion = () => (
    //   <Fragment>
    //     <div className="onboarding-subheader" data-section="frame">
    //       <h3 className="onboarding-subheader_title" data-number={`${questionsCounter()}. `}>
    //         What is your ideal time frame to finish this room?
    //         {error === 'frame' && <FormError error="This question is required" />}
    //       </h3>
    //     </div>
    //     <div className="onboarding-section">
    //       <textarea
    //         className="form-control"
    //         placeholder="Please type here ..."
    //         rows="3"
    //         disabled={disabled}
    //         value={this.state.questionnaire.frame}
    //         onChange={e => this.setQuestionnaireState('frame', e.target.value)}
    //         onBlur={e =>
    //           this.updateProject({ questionnaire_attributes: { frame: e.target.value } })
    //         }
    //       />
    //     </div>
    //   </Fragment>
    // );

    const itemsToSourceQuestion = () => (
      <Fragment>
        <div className="onboarding-subheader" data-section="items_to_buy">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            What items do you already know you want us to source for your room design?
            {this.state.items_to_buy.length && this.state.max_categories
              ? ` (${this.state.max_categories} items max)`
              : null}
            {errorKeys('items_to_buy') && <FormError error="This question is required" />}
          </h3>
        </div>
        <div className="onboarding-subheader-mobile">
          <div className="onboarding-section_title">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              What items do you already know you want us to source for your room design?
              {this.state.items_to_buy.length && this.state.max_categories
                ? ` (${this.state.max_categories} items max)`
                : null}
              {errorKeys('items_to_buy') && <FormError error="This question is required" />}
            </h3>
          </div>
        </div>
        <div className="onboarding-section">
          <Items
            project={this.state}
            updateMC={this.updateMCChecked}
            updateProject={disabled ? noopEvent : this.updateProject}
            disabled={disabled}
          />
        </div>
      </Fragment>
    );

    // const itemsToKeepQuestion = () => (
    //   <Fragment>
    //     <div className="onboarding-subheader" data-section="item_descriptions">
    //       <h3 className="onboarding-subheader_title" data-number={`${questionsCounter()}. `}>
    //         Are there any existing items you'd like to keep?
    //         {error === 'item_descriptions' && <FormError error="This question is required" />}
    //       </h3>
    //     </div>
    //     <div className="onboarding-section">
    //       <textarea
    //         className="form-control"
    //         placeholder="Tell us what are and their dimensions, for example Sofa W220 x D95 x H85 cm. Please also upload some photos below."
    //         rows="3"
    //         disabled={disabled}
    //         value={this.state.questionnaire.item_descriptions}
    //         onChange={e => this.setQuestionnaireState('item_descriptions', e.target.value)}
    //         onBlur={e =>
    //           this.updateProject({
    //             questionnaire_attributes: { item_descriptions: e.target.value },
    //           })
    //         }
    //       />
    //     </div>
    //     <Photos
    //       project={this.state}
    //       images={this.state.images_item}
    //       updateProjectImages={this.updateProjectImages}
    //       deleteImage={this.deleteImage}
    //       onDocumentDelete={this.handleDocumentDelete}
    //       kind="item"
    //       disabled={disabled}
    //     />
    //   </Fragment>
    // );

    // const storageQuestion = () => (
    //   <Fragment>
    //     <div className="onboarding-subheader" data-section="storage">
    //       <h3 className="onboarding-subheader_title" data-number={`${questionsCounter()}. `}>
    //         Tell us about your storage needs
    //         {error === 'storage' && <FormError error="This question is required" />}
    //       </h3>
    //     </div>
    //     <div className="onboarding-section">
    //       <textarea
    //         className="form-control"
    //         placeholder="Do you have a lot of books, clothes, toys you need to store?"
    //         rows="3"
    //         disabled={disabled}
    //         value={this.state.questionnaire.storage}
    //         onChange={e => this.setQuestionnaireState('storage', e.target.value)}
    //         onBlur={e =>
    //           this.updateProject({ questionnaire_attributes: { storage: e.target.value } })
    //         }
    //       />
    //     </div>
    //   </Fragment>
    // );

    const designBrief = () => {
      const cnt = (
        <Fragment>
          {!designFix && (
            <span>
              Your design brief gives us an idea of what you love. What excites you. What would make
              you really happy. It gives your designer a better picture of what you have in mind so
              that they can give you the very best advice and recommendations.
            </span>
          )}
          {designFix && (
            <span>
              Your design brief helps us understand exactly what you need help with,
              so your designer can come to your video call fully prepared to give you the best advice possible.
            </span>
          )}
        </Fragment>
      );
      return (
        <Fragment>
          <div className="onboarding-subheader">
            <h3 className="design_brief_title">Your Design Brief</h3>
            <div className="design_brief_content">
              {cnt}
            </div>
          </div>
          <div className="onboarding-subheader-mobile">
            {/*<h3 className="design_brief_title">Your Design Brief</h3>*/}
            <div className="onboarding-section_title">
              Your Design Brief
            </div>
            {cnt}
          </div>
        </Fragment>
      );
    };
    const itemsStylesQuestion = () => (
      <Fragment>
        {Object.keys(roomTypeOptions).map(roomType => (
          <Fragment key={roomType}>
            <div className="onboarding-anchor-wrapper">
              <div className="onboarding-anchor" data-section={roomType} />
            </div>
            <div className="onboarding-subheader">
              <div className="question-counter" data-number={`${questionsCounter()}`} />
              <h3 className="onboarding-subheader_title">
                {roomTypeOptions[roomType].name}
                {errorKeys(roomType) && <FormError error="This question is required" />}
              </h3>
              <div className="onboarding-section_hint">{roomTypeOptions[roomType].hint}</div>
            </div>
            <div key={roomType} className="onboarding-section">
              <div className="onboarding-subheader-mobile">
                <div
                  className="question-counter-mobile"
                  data-number={`${mobileQuestionsCounter()}`}
                />
                <div className="onboarding-section_title">
                  {roomTypeOptions[roomType].name}
                  {errorKeys(roomType) && <FormError error="This question is required" />}
                </div>
                <div className="onboarding-section_hint">{roomTypeOptions[roomType].hint}</div>
              </div>

              <OptionsList
                disabled={disabled}
                onChange={this.handleReactionChange.bind(this, 'items')}
              >
                {roomTypeOptions[roomType].values.filter(option => !option.archived).map(option => (
                  <OptionsListItemReaction
                    key={option.value}
                    image={option.image}
                    value={option.value}
                    reaction={this.state.questionnaire.items[option.value]}
                    shape={roomTypeOptions[roomType].shape}
                  />
                ))}
              </OptionsList>
            </div>
          </Fragment>
        ))}
      </Fragment>
    );

    const differentInspritationsQuestion = () => {
      return (
        <Fragment>
          {Object.keys(differentInspirationsOptions).map(roomType => (
            <Fragment key={roomType}>
              <div className="onboarding-anchor-wrapper">
                <div className="onboarding-anchor" data-section={roomType} />
              </div>
              <div className="onboarding-subheader">
                <div className="question-counter" data-number={`${questionsCounter()}`} />
                <h3 className="onboarding-subheader_title">
                  {differentInspirationsOptions[roomType].name}
                  {errorKeys(roomType) && <FormError error="This question is required" />}{' '}
                </h3>
                <div className="onboarding-section_hint">Select as many as you wish</div>
              </div>
              <div key={roomType} className="onboarding-section">
                <div className="onboarding-subheader-mobile">
                  <div
                    className="question-counter-mobile"
                    data-number={`${mobileQuestionsCounter()}`}
                  />
                  <div className="onboarding-section_title">
                    {differentInspirationsOptions[roomType].name}
                    {errorKeys(roomType) && <FormError error="This question is required" />}
                  </div>
                  <div className="onboarding-section_hint">
                    {differentInspirationsOptions[roomType].hint}
                  </div>
                </div>
                <OptionsList
                  disabled={disabled}
                  onChange={this.handleReactionChange.bind(this, 'inspirations')}
                  className={'inspirations'}
                >
                  {differentInspirationsOptions[roomType].values
                    .filter(option => !option.archived)
                    .map(option => (
                      <OptionsListItemReaction
                        key={option.value}
                        image={option.image}
                        value={option.value}
                        type={'inspirations'}
                        shape={differentInspirationsOptions[roomType].shape}
                        reaction={this.state.questionnaire.inspirations[option.value]}
                      />
                    ))}
                </OptionsList>
              </div>
            </Fragment>
          ))}
        </Fragment>
      );
    };
    // inspirationOptions

    const materialsQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="material" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            What material finishes do you prefer?
            {errorKeys('material') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        <div className="onboarding-section">
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">
              What material finishes do you prefer?
              {errorKeys('material') && <FormError error="This question is required" />}
            </div>
            <div className="onboarding-section_hint">Select as many as you wish</div>
          </div>
          <OptionsList
            disabled={disabled}
            onChange={this.handleReactionChange.bind(this, 'material')}
            className="material"
          >
            {materialOptions.values.filter(option => !option.archived).map(option => (
              <OptionsListItemReaction
                key={option.value}
                image={option.image}
                value={option.value}
                title={option.title}
                shape={materialOptions.shape}
                reaction={this.state.questionnaire.material[option.value]}
              />
            ))}
          </OptionsList>
        </div>
      </Fragment>
    );

    const fabricFinishesQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="fabric" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Which fabrics do you like best?
            {errorKeys('fabric') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        <div className="onboarding-section">
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">
              Which fabrics do you like best?
              {errorKeys('fabric') && <FormError error="This question is required" />}
            </div>
            <div className="onboarding-section_hint">Select as many as you wish</div>
          </div>
          <OptionsList
            disabled={disabled}
            onChange={this.handleReactionChange.bind(this, 'fabric')}
            className="fabric -items-with-titles"
          >
            {fabricOptions.values.filter(option => !option.archived).map(option => (
              <OptionsListItemReaction
                key={option.value}
                image={option.image}
                shape={fabricOptions.shape}
                value={option.value}
                title={option.title}
                reaction={this.state.questionnaire.fabric[option.value]}
              />
            ))}
          </OptionsList>
        </div>
      </Fragment>
    );

    const colorsQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="color" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Colour likes: Pick the colours that you are most drawn to for this room.
            {errorKeys('color') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        {Object.keys(colorOptions).map(color => (
          <div key={color} className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                Pick the colours that you are most drawn to for this room.
                {errorKeys('color') && <FormError error="This question is required" />}
              </div>
              <div className="onboarding-section_hint">Select as many as you wish</div>
            </div>
            <OptionsList
              disabled={disabled}
              onChange={this.handleReactionChange.bind(this, 'color')}
            >
              {colorOptions[color].values.filter(option => !option.archived).map(option => (
                <OptionsListItemReaction
                  key={option.value}
                  color={option.colour}
                  value={option.value}
                  shape={colorOptions[color].shape}
                  reaction={this.state.questionnaire.color[option.value]}
                />
              ))}
            </OptionsList>
          </div>
        ))}
      </Fragment>
    );

    const coloursDislikesQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="colour_dislikes" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Colour dislikes: It is helpful to know if they're any colours you’d like to avoid
            {errorKeys('colour_dislikes') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        {Object.keys(colorOptions).map(color => (
          <div key={color} className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                It is helpful to know if they're any colours you’d like to avoid
                {errorKeys('colour_dislikes') && <FormError error="This question is required" />}
              </div>
              <div className="onboarding-section_hint">Select as many as you wish</div>
            </div>
            <OptionsList
              disabled={disabled}
              onChange={this.handleReactionChange.bind(this, 'colour_dislikes')}
            >
              {colorOptions[color].values.filter(option => !option.archived).map(option => (
                <OptionsListItemReaction
                  key={option.value}
                  color={option.colour}
                  shape={colorOptions[color].shape}
                  value={option.value}
                  reaction={this.state.questionnaire.colour_dislikes[option.value]}
                />
              ))}
            </OptionsList>
          </div>
        ))}
      </Fragment>
    );

    const artQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="artworks" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Art is very personal. Which of these styles appeal to you?
            {errorKeys('artworks') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        <div className="onboarding-section">
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">
              Art is very personal. Which of these styles appeal to you?
              {errorKeys('artworks') && <FormError error="This question is required" />}
            </div>
            <div className="onboarding-section_hint">Select as many as you wish</div>
          </div>
          <OptionsList
            disabled={disabled}
            onChange={this.handleReactionChange.bind(this, 'artworks')}
          >
            {artOptions.values.filter(option => !option.archived).map(option => (
              <OptionsListItemReaction
                key={option.value}
                image={option.image}
                value={option.value}
                title={option.title}
                reaction={this.state.questionnaire.artworks[option.value]}
                shape={artOptions.shape}
              />
            ))}
          </OptionsList>
        </div>
      </Fragment>
    );

    const patternsQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="pattern" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Which patterns do you prefer?
            {errorKeys('pattern') && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-section_hint">Select as many as you wish</div>
        </div>
        <div className="onboarding-section">
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">
              Which patterns do you prefer?
              {errorKeys('pattern') && <FormError error="This question is required" />}
            </div>
            <div className="onboarding-section_hint">Select as many as you wish</div>
          </div>
          <OptionsList
            disabled={disabled}
            onChange={this.handleReactionChange.bind(this, 'pattern')}
            className="pattern -items-with-titles"
          >
            {patternOptions.values.filter(option => !option.archived).map(option => (
              <OptionsListItemReaction
                key={option.value}
                image={option.image}
                value={option.value}
                title={option.title}
                shape={patternOptions.shape}
                reaction={this.state.questionnaire.pattern[option.value]}
              />
            ))}
          </OptionsList>
        </div>
      </Fragment>
    );

    const budgetQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="budget" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            Give us an idea of the budget you have in mind for your room
            {errorKeys('budget') && <FormError error="This question is required" />}
          </h3>
        </div>
        <div className="onboarding-subheader-mobile">
          <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
          <div className="onboarding-section_title">
            Give us an idea of the budget you have in mind for your room
            {errorKeys('budget') && <FormError error="This question is required" />}
          </div>
        </div>
        <div className="budgetContainer onboarding-section">
          <div>
            <div className="budget-optimal">
              <label htmlFor="budget">Budget</label>
              <select
                id="budget"
                value={this.state.questionnaire.budget.maximum}
                disabled={disabled}
                onChange={this.handleBudgetChange}
                onBlur={e => {
                  // method to pass for saving data
                  const budget = this.state.questionnaire.budget;
                  this.updateProject({ questionnaire_attributes: { budget } });
                }}
              >
                <option>Select here</option>
                {this.state.budgetArray.map((ele, index) => (
                  <option value={ele} key={`${ele}--${index}`}>{`£${ele}`}</option>
                ))}
              </select>
            </div>
            <div className="budget-push">
              <label htmlFor="budgetPush">Budget at a push</label>
              <select
                id="budgetPush"
                value={this.state.questionnaire.budget.optimal}
                onChange={this.handleBudgetPushChange}
                disabled={disabled}
                onBlur={e => {
                  // method to pass for saving data
                  const budget = this.state.questionnaire.budget;
                  this.updateProject({ questionnaire_attributes: { budget } });
                }}
              >
                <option>Select here</option>
                {this.state.budgetPushArray &&
                  this.state.budgetPushArray.map((ele, index) => {
                    return <option value={ele} key={`${ele}--${index}`}>{`£${ele}`}</option>;
                  })}
              </select>
            </div>
          </div>
        </div>
      </Fragment>
    );

    const anythingElseQuestion = () => {
      const text = consultancy
        ? 'Give us some additional context and information, such as what are your main issues , are there ' +
          'things we need to consider, anything specific you want included in the design, are there any ' +
          'storage needs and anything else you think might help.'
        : (designFix ?
          'Please explain the design dilema you’d like help with? The more details the better!' :
          'Is there any additional information you’d like to share?'
        );
      const placeholder = consultancy || designFix
        ? 'Type here.'
        : 'Type here and include the following:\n\n' +
          '• How you’d like to use the room\n' +
          '• Storage requirements\n' +
          '• Any exisiting items to incorporate\n' +
          '• Anything else you think we need to know!\n';
      return (
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="note" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {text}
              {errorKeys('note') && <FormError error="This question is required" />}
            </h3>
          </div>
          <div className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                {text}
                {errorKeys('note') && <FormError error="This question is required" />}
              </div>
            </div>
            <Textarea
              className="form-control additional_info_textarea"
              placeholder={placeholder}
              rows="9"
              disabled={disabled}
              value={this.state.questionnaire.note}
              onChange={e => this.setQuestionnaireState('note', e.target.value)}
              onBlur={e =>
                this.updateProject({ questionnaire_attributes: { note: e.target.value } })
              }
            />
          </div>
        </Fragment>
      );
    };

    const roomPhotosQuestion = () => (
      <Fragment>
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="images_main" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {disabled
                ? 'Uploaded photos of the room'
                : 'Please upload photos of your room. '}
              {errorKeys('images_main') && <FormError error="This question is required" />}
            </h3>
            <div
              className="onboarding-section_hint  why_ask "
              onClick={() => this.setState({ showRoomPhotoHint: true })}
            >
              <span className="underLine">Photo Tips</span> <span className='noUnderLine'>></span>
            </div>
            
          </div>
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">
              {disabled
                ? 'Uploaded photos of the room'
                : 'Please upload photos of your room. '}
              {errorKeys('images_main') && <FormError error="This question is required" />}
            </div>
            <div
              className="onboarding-section_hint  why_ask "
              onClick={() => this.setState({ showRoomPhotoHint: true })}
            >
              <span className="underLine">Photo Tips</span> <span className='noUnderLine'>></span>
            </div>
          </div>
          <div className="onboarding-section">
            <Photos
              project={this.state}
              images={this.state.images_main}
              updateProjectImages={this.updateProjectImages}
              deleteImage={this.deleteImage}
              onDocumentDelete={this.handleDocumentDelete}
              kind="main"
              disabled={disabled}
            />
            <div className="onboarding-section_hint text-center -margin_items-to-incorporate">
              { !designFix &&
                'Don’t forget to also upload photos of\n exisiting items you’d like us to incorporate.'
              }
            </div>
          </div>
        </Fragment>
        <Modal visible={this.state.showRoomPhotoHint} onClose={this.handlePhotoHintClose}>
          <div>
            <div>
              It is important for your designer to be able to visualise your room accurately,
              including any key features and plug positions.
            </div>
            <br />
            <div>
              <ul style={{ padding: '0 10px', 'list-style': 'inside' }}>
                <li>Turn all lights on in the room</li>
                <li>Take a photo of each of the four walls</li>
                <li>Include photos of windows & doors</li>
                <li>Include any important features</li>
              </ul>
            </div>
          </div>
        </Modal>
      </Fragment>
    );

    const inspirationsQuestion = () => {
      const text = (
        <Fragment>
          {!proPlatformAccount && (
            <div>
              Visit out our &nbsp;
              <a
                href="https://www.pinterest.co.uk/mybespokeroom/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Pinterest account</span>
                <span className="-no-underline">{' >'}</span>
              </a>
              &nbsp; for inspiration.
            </div>
          )}
        </Fragment>
      );
      const title = !designFix ? 'It is extremely helpful to share some inspiration on what you like.' : 'Please upload inspiration images (if relevant)'
      return (
        <Fragment>
          <Fragment>
            <div className="onboarding-anchor-wrapper">
              <div className="onboarding-anchor" data-section="inspirations" />
            </div>
            <div className="onboarding-subheader">
              <div className="question-counter" data-number={`${questionsCounter()}`} />
              <h3 className="onboarding-subheader_title">
                {title}
                {errorKeys('inspirations') && <FormError error="This question is required" />}
              </h3>
              {!designFix && (
                <div
                  className="onboarding-subheader_hint why_ask"
                  onClick={() => this.setState({ inspirationPopup: true })}
                >
                  <span className="underLine">Why</span> <span className='noUnderLine'>></span>
                </div>
              )}
            </div>
            <div className="onboarding-subheader-mobile">
              <div className="onboarding-section_title">
                <div
                  className="question-counter-mobile"
                  data-number={`${mobileQuestionsCounter()}`}
                />
                <h3 className="onboarding-subheader_title">
                  {title}
                  {errorKeys('inspirations') && <FormError error="This question is required" />}
                </h3>
              </div>
              {!designFix && (
                <div
                  className="onboarding-section_hint  why_ask "
                  onClick={() => this.setState({ inspirationPopup: true })}
                >
                  <span className="underLine">Why</span> <span className='noUnderLine'>></span>
                </div>
              )}
            </div>
            <div className="onboarding-section">
              <Photos
                project={this.state}
                images={this.state.images_inspiration}
                updateProjectImages={this.updateProjectImages}
                deleteImage={this.deleteImage}
                onDocumentDelete={this.handleDocumentDelete}
                kind="inspiration"
                label="Upload inspiration"
                disabled={disabled}
              />
              <Links
                project={this.state}
                updateProject={disabled ? noopEvent : this.updateProjectLinks}
                disabled={disabled}
              />
            </div>
          </Fragment>
          <Modal visible={this.state.inspirationPopup} onClose={this.handleInspirationPopup}>
            <div>
              This is to get a sense of your personal style and to be able to match you with the
              best designer.
            </div>
            <br />
            <div>
              {' '}
              It also gives your designer a starting point to build ideas for your room design
              direction.{' '}
            </div>
            <br />
            <div>Need inspiration? {text}</div>
          </Modal>
        </Fragment>
      );
    };

    const finishingTouches = () => {
      let countSelected = 0;
      this.state.finishingTouches.forEach(ele => {
        if (ele.selected) {
          countSelected++;
        }
      });
      const text = (
        <Fragment>
          What finishing touches would you like us to source?
          {errorKeys('finishingTouchesRequired') && <FormError error="This question is required" />}
        </Fragment>
      );
      return (
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="finishingTouchesRequired" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {text}
            </h3>
          </div>
          <div className="onboarding-subheader-mobile">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <div className="onboarding-section_title">{text}</div>
            <div className="onboarding-section_hint  why_ask ">Why ask?</div>
          </div>
          <div className="onboarding-section_list">
            {this.state.finishingTouches.map((ele, i) => {
              return (
                <div
                  key={ele.id}
                  onClick={disabled ? undefined : () => this.handleFinishingTouches(i)}
                  className={cn(
                    'onboarding-reaction finishing-touch -select-behaviour',
                    { '-selected': ele.selected },
                    { '-disabled': countSelected === 6 && !ele.selected || disabled },
                  )}
                >
                  <div className="finishing-touches">
                    <SvgIcon className="finishing-touches-icon" icon={ele.icon} />
                    <p className="finishing-touches-title">{ele.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </Fragment>

        /*  <Fragment>
        <div className="onboarding-subheader" data-section="pattern">
          <h3 className="onboarding-subheader_title" data-number={`${questionsCounter()}. `}>
            Which patterns do you prefer?
            {error === 'pattern' && <FormError error="This question is required" />}
          </h3>
          <div className="onboarding-subheader_hint">
            Select as many as you wish
          </div>
        </div>
        <div className="onboarding-section">
          <OptionsList
            disabled={disabled}
            onChange={this.handleReactionChange.bind(this, 'pattern')}
          >
            {patternOptions.values.map(option => (
              <OptionsListItemReaction
                key={option.value}
                image={option.image}
                value={option.value}
                title={option.title}
                shape={patternOptions.shape}
                reaction={this.state.questionnaire.pattern[option.value]}
              />
            ))}
          </OptionsList>
        </div>
      </Fragment>*/
      );
    };

    const roomDimensionsQuestion = () => {
      return (
        <Fragment>
          <Fragment>
            <div className="onboarding-anchor-wrapper">
              <div className="onboarding-anchor" data-section="images_floor_plan" />
            </div>
            <div className="onboarding-subheader">
              <div className="question-counter" data-number={`${questionsCounter()}`} />
              <h3 className="onboarding-subheader_title">
                Finally, upload your room dimensions
                {designFix &&
                  ' (only required if you are requesting help with a room layout).'
                }
                {errorKeys('images_floor_plan') && <FormError error="This question is required" />}
              </h3>
              <div
                className="onboarding-section_hint  why_ask "
                // onClick={() => this.setState({ showRoomPlanHint: true })}
              >
                <span>If you need any tips, our quick measuring guide video will show you everything you need to know.&nbsp;👉&nbsp;</span>
                <a className="underLine" href="https://www.youtube.com/watch?v=mNcLqDzxlBs" target="_blank">Watch now</a>
              </div>
            </div>
            <div className="onboarding-subheader-mobile">
              <div className="onboarding-section_title">
                <div
                  className="question-counter-mobile"
                  data-number={`${mobileQuestionsCounter()}`}
                />
                <h3 className="onboarding-subheader_title">
                  Finally, upload your room dimensions
                  {designFix && (
                    <span>
                    <br/>
                    (only required if you are requesting help with a room layout)
                  </span>
                  )}
                  {errorKeys('images_floor_plan') && (
                    <FormError error="This question is required" />
                  )}
                </h3>
              </div>
              <div
                className="onboarding-section_hint  why_ask "
                // onClick={() => this.setState({ showRoomPlanHint: true })}
              >
                <span>If you need any tips, our quick measuring guide video will show you everything you need to know.&nbsp;👉&nbsp;</span>
                <a className="underLine" href="https://www.youtube.com/watch?v=mNcLqDzxlBs" target="_blank">Watch now</a>
              </div>
            </div>
            <div className="onboarding-section">
              <Photos
                project={this.state}
                images={this.state.images_floor_plan}
                updateProjectImages={this.updateProjectImages}
                deleteImage={this.deleteImage}
                onDocumentDelete={this.handleDocumentDelete}
                kind="floor_plan"
                disabled={disabled}
                label={['Upload', <br key="789" />, 'measurements']}
              />
            </div>
          </Fragment>
          {/*<Modal visible={this.state.showRoomPlanHint} onClose={this.handleShowRoomPlanHintPopup}>*/}
          {/*  <div>*/}
          {/*    <div>*/}
          {/*      We need dimensions to be able to draw up an accurate plan of your room and make sure*/}
          {/*      everything we recommend fits perfectly.*/}
          {/*    </div>*/}
          {/*    <br />*/}
          {/*    <div>A sketch is great, just take a photo and upload it.</div>*/}
          {/*    <br />*/}
          {/*    <div>*/}
          {/*      Please include the ceiling height, wall lengths, power locations, door and window*/}
          {/*      positions and sizes.*/}
          {/*    </div>*/}
          {/*    <br />*/}
          {/*    <div>*/}
          {/*      Need help?*/}
          {/*      <br />*/}
          {/*      <br />*/}
          {/*      <a href="/docs/Mobile Handy Guide - measuring.pdf" target="_blank">*/}
          {/*        <span>View our Measuring guide</span>*/}
          {/*        <span className="-no-underline">{' >'}</span>*/}
          {/*      </a>*/}
          {/*      <br />*/}
          {/*      <br />*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</Modal>*/}
        </Fragment>
      );
    };

    const roomToStyleQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="room_styling_type" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            What room would you like help with?
          </h3>
          {errorKeys('room_styling_type') && <FormError error="This question is required" />}
        </div>
        <div className="onboarding-section">
          <div className="onboarding-subheader-mobile">
            <div className="onboarding-section_title">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <h3 className="onboarding-subheader_title">What room would you like help with?</h3>
              {errorKeys('room_styling_type') && <FormError error="This question is required" />}
            </div>
          </div>
          <div className={cn('onboarding-section_list')}>
            {roomStylingOptions.values.filter(option => !option.archived).map(option => (
              <OptionsListItemImage
                key={option.value}
                icon={`icon_room-${option.icon}`}
                sprite={window.roomIconsSprite}
                value={option.value}
                title={option.title}
                shape={roomStylingOptions.shape}
                disabled={disabled}
                onChange={e => {
                  this.handleRoomStylingTypeChange(option.name, option.value);
                }}
                selected={this.state.questionnaire.room_styling_type === option.value}
              />
            ))}
          </div>
        </div>
      </Fragment>
    );

    // const movingOrImprovingQuestion = () => {
    //   const options = MovingOptions.map(item => (
    //     <option key={item.value} value={item.value}>
    //       {item.label}
    //     </option>
    //   ));
    //   return (
    //     <Fragment>
    //       <div className="onboarding-anchor-wrapper">
    //         <div className="onboarding-anchor" data-section="moving_or_improving" />
    //       </div>
    //       <div className="onboarding-subheader">
    //         <div className="question-counter" data-number={`${questionsCounter()}`} />
    //         <h3 className="onboarding-subheader_title">
    //           Are you moving or improving your current home?
    //           {errorKeys('moving_or_improving') && <FormError error="This question is required" />}
    //         </h3>
    //       </div>
    //       <div className="onboarding-section">
    //         <div className="onboarding-subheader-mobile">
    //           <div
    //             className="question-counter-mobile"
    //             data-number={`${mobileQuestionsCounter()}`}
    //           />
    //           <div className="onboarding-section_title">
    //             Are you moving or improving your current home?
    //             {errorKeys('moving_or_improving') && <FormError error="This question is required" />}
    //           </div>
    //         </div>
    //         <div className="selectors_container">
    //           <div className="dropdown-selector">
    //             <label htmlFor="budget">Are you moving or improving your current home?</label>
    //             <select
    //               value={this.state.questionnaire.moving_or_improving}
    //               className="dropdown_selector"
    //               id="moving_or_improving"
    //               onChange={this.onValueChange('moving_or_improving')}
    //               disabled={disabled}
    //             >
    //               <option>select here</option>
    //               {options}
    //             </select>
    //           </div>
    //         </div>
    //       </div>
    //     </Fragment>
    //   );
    // };

    const ownershipStageQuestion = () => {
      const questionTitle = 'Which statement best describes your situation?';
      const handleCheckboxChange = event => {
        const { value, checked } = event.target;
        this.setState(prevState => {
          return {
            questionnaire: {
              ...prevState.questionnaire,
              ownership_stage: value,
            },
          };
        });
        this.updateProject({ questionnaire_attributes: { ownership_stage: value } });
      };

      const options = OwnershipStageOptions.map(item => (
        <div key={item.value} className="checkbox-option">
          <input className='onboarding-selection_input'
                 id={`options-list-item-${item.value}`}
                 name={'ownership_stage'}
                 type="radio"
                 value={item.value}
                 defaultChecked={this.state.questionnaire.ownership_stage === item.value }
                 onChange={handleCheckboxChange}
                 disabled={disabled}
          />
          <label className='onboarding-selection_label' htmlFor={`options-list-item-${item.value}`} >
            {item.label}
          </label>
        </div>
      ));

      return (
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="ownership_stage" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {questionTitle}
              {errorKeys('ownership_stage') && <FormError error="This question is required" />}
            </h3>
          </div>
          <div className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                {questionTitle}
                {errorKeys('ownership_stage') && <FormError error="This question is required" />}
              </div>
            </div>
            <div className="selectors_container">
              <div className="checkbox-group">
                {options}
              </div>
            </div>
          </div>
        </Fragment>
      );
    };

    const completionTimelineQuestion = () => {
      const questionTitle = 'When are you looking to complete this room?';

      const handleCheckboxChange = event => {
        const { value, checked } = event.target;
        this.setState(prevState => {
          return {
            questionnaire: {
              ...prevState.questionnaire,
              completion_timeline: value,
            },
          };
        });
        this.updateProject({ questionnaire_attributes: { completion_timeline: value } });
      };

      const options = CompletionTimelineOptions.map(item => (
        <div key={item.value} className="checkbox-option">
          <input className='onboarding-selection_input'
                 id={`options-list-item-${item.value}`}
                 name={'completion_timeline'}
                 type="radio"
                 value={item.value}
                 defaultChecked={this.state.questionnaire.completion_timeline === item.value }
                 onChange={handleCheckboxChange}
                 disabled={disabled}
          />
          <label className='onboarding-selection_label' htmlFor={`options-list-item-${item.value}`} >
            {item.label}
          </label>
        </div>
      ));

      return (
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="completion_timeline" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {questionTitle}
              {errorKeys('completion_timeline') && <FormError error="This question is required" />}
            </h3>
          </div>
          <div className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                {questionTitle}
                {errorKeys('completion_timeline') && <FormError error="This question is required" />}
              </div>
            </div>
            <div className="selectors_container">
              <div className="checkbox-group">
                {options}
              </div>
            </div>
          </div>
        </Fragment>
      );
    };

    const homeActivitiesQuestion = () => {

      const questionTitle = 'Are you?';
      const handleCheckboxChange = event => {
        const { value, checked } = event.target;
        const currentSelection = this.state.questionnaire.home_activities || [];
        const updatedSelection = checked
          ? [...currentSelection, value]
          : currentSelection.filter(option => option !== value);
        this.setState(prevState => {
          return {
            questionnaire: {
              ...prevState.questionnaire,
              home_activities: updatedSelection,
            },
          };
        });
        this.updateProject({ questionnaire_attributes: { home_activities: updatedSelection } });
      };

      const options = HomeActivitiesOptions.map(item => (
        <div key={item.value} className="checkbox-option">
          <input className='onboarding-selection_input'
            id={`options-list-item-${item.value}`}
            type="checkbox"
            value={item.value}
            defaultChecked={(this.state.questionnaire.home_activities || []).includes(item.value) || false}
            onChange={handleCheckboxChange}
            disabled={disabled}
          />
          <label className='onboarding-selection_label' htmlFor={`options-list-item-${item.value}`} >
            {item.label}
          </label>
        </div>
      ));

      return (
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="home_activities" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              {questionTitle}
              {errorKeys('home_activities') && <FormError error="This question is required" />}
            </h3>
            <div className="onboarding-section_hint">You can select multiple options</div>
          </div>
          <div className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                {questionTitle}
                {errorKeys('home_activities') && <FormError error="This question is required" />}
              </div>
              <div className="onboarding-section_hint">You can select multiple options</div>
            </div>
            <div className="selectors_container">
              <div className="checkbox-group">
                {/*<label>(You can select multiple options)</label>*/}
                {options}
              </div>
            </div>
          </div>
        </Fragment>
      );
    };



    const familyMembersQuestion = () => (
      <Fragment>
        <Fragment>
          <div className="onboarding-anchor-wrapper">
            <div className="onboarding-anchor" data-section="family_members" />
          </div>
          <div className="onboarding-subheader">
            <div className="question-counter" data-number={`${questionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              Who will be using the space?
              {errorKeys('family_members') && <FormError error="This question is required" />}
            </h3>
            {/* <div
              className="onboarding-section_hint  why_ask "
            >
              Why ask?
            </div> */}
          </div>
          <div className="onboarding-section">
            <div className="onboarding-subheader-mobile">
              <div
                className="question-counter-mobile"
                data-number={`${mobileQuestionsCounter()}`}
              />
              <div className="onboarding-section_title">
                Tell us who is going to use the space?
                {errorKeys('family_members') && <FormError error="This question is required" />}
              </div>
              {/* <div
                className="onboarding-section_hint  why_ask "
              >
                Why ask?
              </div> */}
            </div>
            <div className="selectors_container">
              <div
                className={cn('tell_ages -display-behaviour', {
                  '-show': this.state.noOfAdults > 0 || this.state.noOfChild > 0,
                })}
              >
                Tell us their ages
              </div>
              <div className="adult_selector">
                <label htmlFor="adult">Adults (18+)</label>
                <select
                  value={this.state.noOfAdults}
                  className="adult_select"
                  id="adult"
                  onChange={this.handleAdultChange}
                  disabled={disabled}
                >
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                </select>
                {this.renderAdultDropDown()}
              </div>

              <div className="child_selector">
                <label htmlFor="child">Children (0-17)</label>
                <select
                  value={this.state.noOfChild}
                  className="child_select"
                  id="child"
                  onChange={this.handleChildChange}
                  disabled={disabled}
                >
                  <option>0</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                </select>
                {this.renderChildDropDown()}
              </div>
            </div>
          </div>
        </Fragment>
        <Modal visible={this.state.whyAskFamilyPopup} onClose={this.hideWhyAskFamilyPopup}>
          <div>
            <div>
              It is important for your designer to be able to visualise your room accurately,
              including any key features and plug positions.
            </div>
            <br />
            <div>
              It also gives your designer a starting point to build ideas for your room design
              direction.
            </div>
          </div>
        </Modal>
      </Fragment>
    );

    const propertyAddressQuestion = () => (
      <Fragment>
        <div className="onboarding-anchor-wrapper">
          <div className="onboarding-anchor" data-section="address" />
        </div>
        <div className="onboarding-subheader">
          <div className="question-counter" data-number={`${questionsCounter()}`} />
          <h3 className="onboarding-subheader_title">
            What is your property address?
            {errorKeys('address') && <FormError error="This question is required" />}
          </h3>
        </div>
        <div className="onboarding-subheader-mobile">
          <div className="onboarding-section_title">
            <div className="question-counter-mobile" data-number={`${mobileQuestionsCounter()}`} />
            <h3 className="onboarding-subheader_title">
              What is your property address?
              {errorKeys('address') && <FormError error="This question is required" />}
            </h3>
          </div>
        </div>

        <div className="onboarding-section -row">
          <input
            className="form-control onboarding-section_input"
            placeholder="Address"
            type="text"
            disabled={disabled}
            value={this.state.questionnaire.address}
            onChange={e => this.setQuestionnaireState('address', e.target.value)}
            onBlur={e =>
              this.updateProject({ questionnaire_attributes: { address: e.target.value } })
            }
          />

          <input
            className="form-control onboarding-section_input"
            placeholder="Town"
            type="text"
            disabled={disabled}
            value={this.state.questionnaire.town}
            onChange={e => {
              this.setQuestionnaireState('town', e.target.value);
            }}
            onBlur={e => {
              this.updateProject({ questionnaire_attributes: { town: e.target.value } });
            }}
          />

          <input
            className="form-control onboarding-section_input"
            placeholder="Postcode"
            type="text"
            disabled={disabled}
            value={this.state.questionnaire.postcode}
            onChange={e => {
              this.setQuestionnaireState('postcode', e.target.value);
            }}
            onBlur={e => {
              this.updateProject({ questionnaire_attributes: { postcode: e.target.value } });
            }}
          />
        </div>
      </Fragment>
    );


    const renderQuestions = () => {
      if (consultancy) {
        return (
          <Fragment>
            {designBrief()}
            {propertyAddressQuestion()}
            {familyMembersQuestion()}
            {anythingElseQuestion()}
            {roomPhotosQuestion()}
            {roomDimensionsQuestion()}
            {inspirationsQuestion()}
            {finishingTouches()}
          </Fragment>
        );
      };

      if (designFix) {
        return (
          <Fragment>
            {designBrief()}
            {roomToStyleQuestion()}
            {familyMembersQuestion()}
            {anythingElseQuestion()}
            {roomPhotosQuestion()}
            {inspirationsQuestion()}
            {roomDimensionsQuestion()}
          </Fragment>
        );
      };

      return (
        <Fragment>
          {designBrief()}
          {/*{issuesQuestion()}*/}
          {/*{timeFrameQuestion()}*/}
          {/*{itemsToKeepQuestion()}*/}
          {/*{storageQuestion()}*/}
          {roomStyling || designFix ? roomToStyleQuestion() : null}
          {differentInspirationsOptions ? differentInspritationsQuestion() : null}
          {colorsQuestion()}
          {/* {coloursDislikesQuestion()} */}
          {roomTypeOptions ? itemsStylesQuestion() : null}
          {/* {roomStyling ? itemsToSourceQuestion() : null} */}
          {artQuestion()}
          {patternsQuestion()}
          {fabricFinishesQuestion()}
          {materialsQuestion()}
          {roomStyling || designFix ? finishingTouches() : null}
          {/*{movingOrImprovingQuestion()}*/}
          {ownershipStageQuestion()}
          {/*{homeActivitiesQuestion()}*/}
          {familyMembersQuestion()}
          {budgetQuestion()}
          {completionTimelineQuestion()}
          {anythingElseQuestion()}
          {roomPhotosQuestion()}
          {inspirationsQuestion()}
          {roomDimensionsQuestion()}
        </Fragment>
      );
    };

    return (
      <div className="designs-list -onboarding">
        <div className="container">
          <div className="onboarding-container">
            {renderQuestions()}
          </div>
          <div className="onboarding-container -footer">
            <div className="footer-container">
              {submitted || disabled ?
                <a href='/projects/'
                  className="btn -btn-2023 -longer onboarding-submit"
                >
                  Close
                </a>
                : <button
                  className="btn -btn-2023 -longer onboarding-submit"
                  disabled={disabled}
                  onClick={() =>
                    this.sendToDesigner(roomStyling, designFix, differentInspirationsOptions, roomTypeOptions)
                  }
                >
                  {disabled ? 'Submitted' : submitButtonName}
                </button>
              }
              <span>
                <Status error={project.error} updated_at={updatedAtFormatted} />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/CustomerDesign/Form.js